import { createRoot } from 'react-dom/client';
import { HashRouter, Route, Routes } from 'react-router-dom';

import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

import { ConfirmPopup } from 'primereact/confirmpopup';
import { AppConfirmDialog, AppToast, DefaultConf, ScrollToTop } from '@iamsoftware/react-hooks';

import './assets/layout/layout.scss';
import '@iamsoftware/react-hooks/assets/style.scss';
import './App.scss';

import { PrimeReactProvider } from 'primereact/api';

import { LayoutProvider } from 'src/layout/context/layoutcontext';

import { AppLoading } from 'src/AppLoading';

import App from 'src/app';
import Login from 'src/pages/login';
import { Sign } from './pages/ky-hop-dong';

document.documentElement.style.fontSize = '14px';

DefaultConf.DataTable.IndexColumnHeader = '#';
DefaultConf.DataTable.ItemsField = 'listData';

const root = createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(

  <HashRouter>
    <ScrollToTop>
      <PrimeReactProvider>
        <LayoutProvider>
          <ConfirmPopup />
          <Routes>
            <Route path="login" element={<Login />} />
            <Route path="ky-hop-dong" element={<Sign />} />
            <Route path="*" element={<App />} />
          </Routes>
          <AppLoading />
          <AppToast />
          <AppConfirmDialog />
        </LayoutProvider>
      </PrimeReactProvider>
    </ScrollToTop>
  </HashRouter>
);
